<template>
    <div>
        <div>Prossima disponibilità: {{moveToDate | moment("dddd DD MMMM")}}</div>
        <button class="btn btn-sm btn-primary mt-1 mb-1" v-on:click="handleClick">
            Vai al {{moveToDate | moment("DD-MM-YYYY")}}
        </button>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment';

export default {
    mounted() {},
    methods: {
        handleClick() {
            this.$emit('change-date', moment(this.moveToDate).toDate());
        },
    },
    data() {
        return {};
    },
    props: {
        moveToDate: VueTypes.date,
    },
    filters: {
    },
};
</script>

<style>
.card-image img {
    max-height: 160px;
}
</style>
